import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import { SearchButton as SearchBtn } from 'screens/HomePageCommercial/sections/styled';
import { typographyFontSizeCfg } from 'ds/components/typography/types';

export const SearchRoot = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(1)};
    background: ${colorToAlpha(theme.colors.neutrals.white, 0.6)};
    border-radius: ${theme.borderRadius.small};
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    width: 430px;
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    width: 503px;
  `}
  ${({ theme }) => `
    display: flex;
    &&& {
      .textfield-input {
        width: 100%;
        border: 2px solid ${theme.colors.neutrals.grey8};
        border-left: none;
      }
    }
  `}
`;

export const SearchButton = styled(SearchBtn)`
  ${({ theme }) => `
    border: 2px solid ${theme.colors.neutrals.grey8};
    border-right: none;
    background-color: ${theme.colors.brand.main};
    font-size: ${typographyFontSizeCfg.text}px;
    &:hover {
      background-color: ${theme.colors.brand.darker};
    }
  `}
`;
